import { styled } from "@mui/system";
import { Box, Card, Typography, Chip } from "@mui/material";
import { colors, fontFamilies } from "../../../../../constants/theme";
import { SectionHeading as BaseSectionHeading } from "../../../../../ui/typography";

export const SectionWrapper = styled(Box)(({ theme }) => ({
  padding: "40px 40px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
  [theme.breakpoints.down("md")]: {
    padding: "30px 20px",
  },
}));

export const ContentWrapper = styled(Box)(({ theme }) => ({
  maxWidth: 1200,
  width: "100%",
  margin: "0 auto",
  [theme.breakpoints.down("md")]: { padding: "0 16px" },
}));

export const SectionHeading = styled(BaseSectionHeading)(({ theme }) => ({
  ...theme.typography.heading,
  textAlign: "center",
  marginBottom: 32,
  width: "100%",
}));

export const CredentialsGrid = styled(Box)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: 24,
  width: "100%",
  justifyContent: "center",
  [theme.breakpoints.down("md")]: {
    gridTemplateColumns: "1fr",
  },
}));

export const CredentialCard = styled(Card)({
  backgroundColor: "#fff",
  borderRadius: 16,
  padding: 32,
  boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
  minHeight: 300,
  height: "100%",
  display: "flex",
  flexDirection: "column",
  width: "100%",
  transition: "transform 0.2s, box-shadow 0.2s",
  "&:hover": {
    transform: "translateY(-3px)",
    boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
  },
});

export const CardTitle = styled(Typography)({
  fontFamily: fontFamilies.gotham,
  fontSize: 20,
  fontWeight: 600,
  color: colors.primary,
  marginBottom: 16,
});

export const ListContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: 8,
  flex: 1,
  overflow: "auto",
  width: "100%",
});

export const ListItemText = styled(Typography)({
  fontFamily: fontFamilies.quicksand,
  fontSize: 16,
  fontWeight: 400,
  color: "#2c2c2c",
  lineHeight: 1.5,
  display: "flex",
  alignItems: "flex-start",
  width: "100%",
  "&:before": {
    content: '"•"',
    marginRight: 12,
    color: "#29405A",
    fontWeight: 700,
    flexShrink: 0,
  },
});

export const LanguagesContainer = styled(Box)({
  display: "flex",
  flexWrap: "wrap",
  gap: 12,
  flex: 1,
  alignContent: "flex-start",
  overflow: "auto",
  width: "100%",
});

export const LanguageChip = styled(Chip)({
  backgroundColor: "#29405A",
  color: "#FFF",
  fontFamily: fontFamilies.quicksand,
  fontSize: 14,
  fontWeight: 600,
  padding: "8px 16px",
  height: "auto",
  minHeight: 32,
  borderRadius: 16,
});
